import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API ||
  "https://backdanlu.eu-4.evennode.com";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.token = token;
  }

  return config;
});

function mensajeError(error) {
  const data = error?.response?.data;

  const candidatos = [
    data?.msg,
    data?.err?.message,
    data?.err,
    data?.error?.message,
    data?.error,
    data?.message,
    error?.message,
  ];

  const mensaje = candidatos.find(
    (valor) => typeof valor === "string" && valor.trim()
  );

  return mensaje || "No se pudo completar la operación.";
}

export default function crearApiOrdenesRemito(path, persona) {
  async function ejecutar(peticion) {
    try {
      const { data } = await peticion();
      return data;
    } catch (error) {
      return {
        ok: false,
        msg: mensajeError(error),
      };
    }
  }

  return {
    crear: (payload) =>
      ejecutar(() => api.post(path, payload)),

    obtener: (id) =>
      ejecutar(() =>
        api.get(`${path}/${encodeURIComponent(id)}`)
      ),

    listar: (params = {}) =>
      ejecutar(() => api.get(path, { params })),

    pendientes: (personaId) =>
      ejecutar(() =>
        api.get(`${path}/pendientes`, {
          params: { [persona]: personaId },
        })
      ),

    creditos: (personaId) =>
      ejecutar(() =>
        api.get(`${path}/creditos-disponibles`, {
          params: { [persona]: personaId },
        })
      ),

    anular: (id) =>
      ejecutar(() =>
        api.put(`${path}/${encodeURIComponent(id)}/anular`, {})
      ),

    actualizarObservaciones: (id, observaciones) =>
      ejecutar(() =>
        api.put(`${path}/${encodeURIComponent(id)}`, {
          observaciones,
        })
      ),
  };
}